import { flyingInsectTypeMap } from '@/libs/insectTypes';

export default {
  methods: {
    calcRouteCounts(insectCounts) {
      const result = { indoor: 0, outdoor: 0 };
      const insectTypes = flyingInsectTypeMap(this.$i18n.locale);

      Object.keys(insectCounts).forEach((insectType) => {
        const routeType = insectTypes[insectType].route;
        result[routeType] += insectCounts[insectType];
      });

      return result;
    },
  },
};
